document.addEventListener("input", function (e) {
  if (!e.target.classList.contains("quantity__input")) return;
  const input = e.target;

  if (input.value === "") return;

  const min = parseInt(input.dataset.min);
  const max = input.dataset.max ? parseInt(input.dataset.max) : Infinity;
  const step = parseInt(input.dataset.step) || 1;

  let value = parseInt(input.value);

  if (isNaN(value)) return;
  if (min && value < min) value = min;
  if (value > max) value = max;
  if (min && (value - min) % step !== 0) {
    value = Math.round((value - min) / step) * step + min;
  }
  input.value = value;

  input.dispatchEvent(new Event("change", { bubbles: true }));
});


document.addEventListener('DOMContentLoaded', () => {

  function formatMoney(cents) {
    // format without NZ currency
    return '$' + (cents / 100).toFixed(2);
  }

  function initLivePrice(wrapper) {
    const qtyInput = wrapper.querySelector('input[name="quantity"]');
    if (!qtyInput) return;

    const priceWrapper = document.querySelector('[data-unit-price]');
    if (!priceWrapper) return;

    const priceEl = priceWrapper.querySelector('[data-qty-subtotal]');
    if (!priceEl) return;

    const unitPrice = parseInt(priceWrapper.dataset.unitPrice, 10);
    if (isNaN(unitPrice)) return;

    const updatePrice = () => {
      let qty = parseInt(qtyInput.value, 10);
      if (isNaN(qty) || qty < 1) qty = 1;

      const total = unitPrice * qty;
      priceEl.textContent = formatMoney(total);
    };

    qtyInput.addEventListener('input', updatePrice);
    qtyInput.addEventListener('change', updatePrice);
    qtyInput.addEventListener('blur', updatePrice);

    updatePrice();
  }

  document
    .querySelectorAll('.quantity-input_fielder-wrap')
    .forEach(initLivePrice);

  new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (node.nodeType === 1) {
          node
            .querySelectorAll?.('.quantity-input_fielder-wrap')
            .forEach(initLivePrice);
        }
      });
    });
  }).observe(document.body, { childList: true, subtree: true });

});


(function () {
  const originalFetch = window.fetch;
  function hideQtyError(qtyInput) {
    if (!qtyInput) return;
    const container = qtyInput.closest('form') || qtyInput.closest('.quick-view') || document;
    const errorEl = container.querySelector('[data-error-container], .cart-qty-error');
    if (errorEl) {
      errorEl.style.display = 'none';
      errorEl.textContent = '';
    }
  }

  function showQtyError(qtyInput, message) {
    if (!qtyInput) return;

    let container = qtyInput.closest('form') || 
                    qtyInput.closest('.quick-view') || 
                    document;
    const productWrap = qtyInput.closest('.product-column_atc-wrap');
    if (productWrap) {
      container = productWrap;
    }

    let errorEl = container.querySelector('[data-error-container], .cart-qty-error');

    if (!errorEl) {
      errorEl = document.createElement('div');
      errorEl.className = 'cart-qty-error';
      container.appendChild(errorEl);
    }

    if (errorEl.textContent === message && errorEl.style.display === 'block') {
      return;
    }

    errorEl.textContent = message;
    errorEl.style.color = '#d72c2c';
    errorEl.style.display = 'block';
    errorEl.style.marginTop = '10px';
    errorEl.setAttribute('aria-live', 'assertive');
  }

  document.addEventListener('change', function(e) {
    if (e.target.name === 'quantity' || e.target.name === 'updates[]') {
      hideQtyError(e.target);
    }
  });

  function getQtyInput(formId, body) {
    if (formId) {
      const form = document.getElementById(formId);
      if (form) return form.querySelector('input[name="quantity"]');
    }

    const activeModal = document.querySelector('.modal--active, .quick-view-open, .is-open, .quick-view');
    if (activeModal) {
      const modalInput = activeModal.querySelector('input[name="quantity"]');
      if (modalInput) return modalInput;
    }

    const variantId = body?.get('id');
    if (variantId) {
      const inputs = document.querySelectorAll('input[name="quantity"]');
      for (const input of inputs) {
        if (input.form && input.form.querySelector(`input[name="id"][value="${variantId}"]`)) {
          return input;
        }
      }
    }
    return document.querySelector('input[name="quantity"]:not([disabled])');
  }

  window.fetch = async function () {
    const args = arguments;
    const url = args[0];
    const options = args[1];

    if (
      typeof url === 'string' &&
      url.includes('/cart/add') &&
      options?.body instanceof FormData
    ) {
      const body = options.body;
      const variantId = body.get('id');
      const qtyToAdd = parseInt(body.get('quantity') || 1, 10);
      const formId = body.get('form_id');

      const qtyInput = getQtyInput(formId, body);
      const form = qtyInput?.closest('form');

      let maxQty =
        parseInt(qtyInput?.dataset.max, 10) ||
        parseInt(qtyInput?.getAttribute('max'), 10) ||
        parseInt(form?.dataset.max, 10);

      const cartRes = await originalFetch('/cart.js');
      const cart = await cartRes.json();

      const existingItem = cart.items.find(
        item => String(item.variant_id) === String(variantId)
      );

      const existingQty = existingItem ? existingItem.quantity : 0;
      const totalPotentialQty = existingQty + qtyToAdd;

      if ((!maxQty || isNaN(maxQty)) && qtyInput?.type === 'hidden') {
        maxQty = qtyToAdd;
      }

      if (maxQty && totalPotentialQty > maxQty) {
        const errorMsg = `You can only purchase up to ${maxQty} units of this product.`;

        showQtyError(qtyInput, errorMsg);

        return new Response(
          JSON.stringify({
            status: 422,
            message: errorMsg,
            description: errorMsg
          }),
          {
            status: 422,
            headers: { 'Content-Type': 'application/json' }
          }
        );
      } else {
        hideQtyError(qtyInput);
      }
    }
    return originalFetch.apply(this, args);
  };
})();



document.addEventListener('DOMContentLoaded', () => {

  function initQuantity(wrapper) {
    const input = wrapper.querySelector('input[name="quantity"]')
    const btnPlus = wrapper.querySelector('button[name="plus"]')
    const btnMinus = wrapper.querySelector('button[name="minus"]')
    if (!input || !btnPlus || !btnMinus) return

    const min  = parseInt(input.dataset.min || input.min || 1, 10)
    const max  = input.dataset.max ? parseInt(input.dataset.max, 10) : null
    const step = parseInt(input.dataset.step || 1, 10)

    input.step = 1 

    const clamp = value => {
      if (isNaN(value)) value = min
      const index = Math.round((value - min) / step)
      value = min + index * step

      if (value < min) value = min
      if (max !== null && value > max) value = max

      return value
    }

    const updateButtons = () => {
      const val = parseInt(input.value, 10)
      btnMinus.disabled = val <= min
      if (max !== null) btnPlus.disabled = val >= max
    }

    btnPlus.addEventListener('click', e => {
      e.preventDefault()
      e.stopImmediatePropagation()

      let current = parseInt(input.value, 10)
      if (isNaN(current)) current = min

      input.value = clamp(current + step)
      input.dispatchEvent(new Event('change', { bubbles: true }))
    }, true)

    btnMinus.addEventListener('click', e => {
      e.preventDefault()
      e.stopImmediatePropagation()

      let current = parseInt(input.value, 10)
      if (isNaN(current)) current = min

      input.value = clamp(current - step)
      input.dispatchEvent(new Event('change', { bubbles: true }))
    }, true)

    input.addEventListener('change', () => {
      input.value = clamp(parseInt(input.value, 10))
      updateButtons()
    })

    input.addEventListener('blur', () => {
      input.value = clamp(parseInt(input.value, 10))
      updateButtons()
    })

    input.value = clamp(parseInt(input.value, 10))
    updateButtons()
  }

  document.querySelectorAll('.quantity-input_fielder-wrap').forEach(initQuantity)
  new MutationObserver(mutations => {
    mutations.forEach(m => {
      m.addedNodes.forEach(node => {
        if (node.nodeType === 1) {
          node.querySelectorAll?.('.quantity-input_fielder-wrap').forEach(initQuantity)
        }
      })
    })
  }).observe(document.body, { childList: true, subtree: true })
})